import { Badge } from '@cloudflare/kumo'
import type { MenuTagRow } from '../lib/community-concerns'

/** 메뉴 꼬리표를 축마다 한 줄로 (커뮤니티 글 상세, 시뮬레이션 상세) */
export function MenuTagList({ rows }: { rows: MenuTagRow[] }) {
  if (!rows.length) return <span className="text-kumo-subtle">없음</span>
  return (
    <ul className="flex flex-col gap-1" data-testid="menu-tag-list">
      {rows.map((r) => (
        <li key={r.axis} className="flex flex-wrap items-center gap-1">
          <span className="text-kumo-subtle w-24 shrink-0 text-xs">{r.axisLabel}</span>
          {r.labels.map((label) => (
            <Badge key={label} variant="outline">
              {label}
            </Badge>
          ))}
        </li>
      ))}
    </ul>
  )
}
